import { cn } from "~/lib/utils";

/** A text tab over a black page, marked by weight and a short underline. */
export function UnderlineTab({
  id,
  label,
  active,
  onClick,
}: {
  id: string;
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      id={id}
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={cn(
        "flex shrink-0 cursor-pointer flex-col items-center gap-[6px] text-[14px] leading-[20px] whitespace-nowrap",
        active ? "font-semibold text-white" : "font-medium text-white/70"
      )}
    >
      {label}
      <span className={cn("h-[3px] w-full rounded-t-[10px]", active ? "bg-white" : "bg-transparent")} />
    </button>
  );
}
